import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '@/config/api.config';

export const roleService = {
  async getRoles() {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.ROLES.BASE}`,
        {
          params: { hidden: false },
        },
      );
      return response.data;
    } catch (error) {
      console.error('getRoles service error:', error);
      throw error;
    }
  },
};
